﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:weekSwitcher
 * @description
 * # weekSwitcher
 */
angular.module('ntmApp')
  .directive('weekSwitcher', function () {
      return {
          restrict: 'E',
          templateUrl: 'src/directives/templates/weekSwitcher.html',
          scope: {
              items: '=',
              selectedWeek: '=',
              setCurrentWeek: '&'
          },
          link: function (scope) {
              scope.change = function (week, action) {
                  if (action) {
                      if (action === 'prev') {
                          week = scope.items[week.week - 2];
                      }
                      if (action === 'next') {
                          week = scope.items[week.week];
                      }
                  }

                  if (scope.selectedWeek.startDate !== week.startDate) {
                      scope.setCurrentWeek({ week: week.week });
                      scope.selectedWeekStr = buildDate(week);
                  }
              };

              function buildDate(week) {
                  if (!week) {
                      return;
                  }

                  var str = '{0} - {1}';

                  if (week.startDate.format('YYYY') !== week.endDate.format('YYYY')) {
                      str = str.format(week.startDate.format('MMM DD, YYYY'), week.endDate.format('MMM DD, YYYY'));
                  } else if (week.startDate.format('M') !== week.endDate.format('M')) {
                      str = str.format(week.startDate.format('MMM DD'), week.endDate.format('MMM DD, YYYY'));
                  } else {
                      str = str.format(week.startDate.format('MMM DD'), week.endDate.format('DD, YYYY'));
                  }

                  return str;
              }

              scope.selectedWeekStr = buildDate(scope.selectedWeek);
              scope.items.forEach(function (item) {
                  item.weekStr = buildDate(item);
              });
          }
      };
  });